import { render } from "./07fcd944-7ce5-11eb-811b-00155d01060e.vue?vue&type=template&id=386956f1"
import script from "./07fcd944-7ce5-11eb-811b-00155d01060e.vue?vue&type=script&lang=js"
export * from "./07fcd944-7ce5-11eb-811b-00155d01060e.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__